import axios from '../../../config/axiosConfig';
import { Admin, AdminStudent, ExportDocumentTypes, ExportFormat, isType } from '../../../shared';
import { ErrorResponse } from '../../../shared';
import { IStudentItem, ReportRows, StudentItemResponse } from './StudentItem.interfaces';

export const fetchStudentItem = async (admin: Admin, student: AdminStudent, fromQuiz: boolean, abortController: AbortController):
  Promise<StudentItemResponse | ErrorResponse> => {
  const body = {
    adminId: admin.administrationID,
    studentId: student.testTakerName,
    isEndOfQuiz: fromQuiz
  };
  // await new Promise(resolve => setTimeout(resolve, 0));
  // return SAMPLE_DATA;

  const response = await axios.post<IStudentItem>(
    'api/report/studentItem', body, {signal: abortController.signal}
  )
    .then((res):StudentItemResponse => ({studentItem: res.data, __typename: 'StudentItemResponse'}))
    .catch((errMsg):ErrorResponse => ({__typename: 'ErrorResponse', errMsg}));
  return response;
};

export const fetchStudentItemWithRetry = async (admin: Admin, student: AdminStudent, fromQuiz: boolean, abortController: AbortController):
  Promise<StudentItemResponse | ErrorResponse> => {

  let retry = 0;

  while (retry++ < 1) {
    const response = await fetchStudentItem(admin, student, fromQuiz, abortController);
    if (response.__typename === 'ErrorResponse') {
      return response;
    }
    if (
      isType<StudentItemResponse>(
        response,
        'StudentItemResponse'
      )
    ) {
      if (response.studentItem.reportDataExists) {
        return response;
      } else if (response.studentItem.resultsNotReady) {
        await new Promise(resolve => setTimeout(resolve, 5000));
      } else {
        // no data
        return response;
      }
    }
    
    if (retry === 1) {
      return response;
    }
  }

  return {__typename: 'StudentItemResponse',   studentItem: {
    reportDataExists: false,
    resultsNotReady: true,
    reportRows: []
  }
  };

};

export const downloadStudentItemReport = async (compReport: ReportRows[], exportSignal: ExportFormat ): Promise<boolean> => {
  const body = {reports: compReport, exportFormat: exportSignal, documentType: 'StuItem' as ExportDocumentTypes};
  // const formData = {reports: compReport, files: [] };
  const url = 'api/export/reportexport';
  try {
    const response = await axios.post<Blob>(url, body, { responseType: 'blob'});
    // Create a new Blob object using the response data of the file
    const file = new Blob([response.data], { type: response.headers['content-type'] });
    const contentDisposition = response.headers['content-disposition'] as string;

    let fileName = '';
    const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/gi;
    const matches = regex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, ''); // Remove any surrounding quotes
      console.log(fileName);
    }
    // Create a link to the file
    const fileURL = URL.createObjectURL(file);

    // Create a temporary anchor tag and trigger a download
    const fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();

    // Clean up by removing the link and revoking the object URL
    document.body.removeChild(fileLink);
    URL.revokeObjectURL(fileURL);
    return true;
  } catch(err) {
    return false;
  }
};
